module.exports = __webpack_public_path__ + "img/sign-in.797bb368.svg";